export const API_URL:string = "https://api.legendsportmanagement.com/"
